import type { BackgroundMapCustomOptions } from "@mm/metx-workbench.meteomatics.com";
import { MaptilerCustomBackgroundMapId } from "./maptilerStyleOptions";

export type BackgroundMapCustomColorOptions = {
  custom_background_color?: string | null;
  custom_water_color?: string | null;
  custom_border_color?: string | null;
};

export const backgroundMapCustomStyleDefaults = {
  backgroundColor: "#A5C3A6",
  waterColor: "#28465E",
  borderColor: "#504E4E",
} as const;

export function isCustomBackgroundMapStyle(styleId: string): boolean {
  return styleId === MaptilerCustomBackgroundMapId;
}

export function resolveCustomBackgroundMapColors(customOptions: BackgroundMapCustomOptions | null | undefined) {
  const customColorOptions = (customOptions ?? {}) as BackgroundMapCustomOptions & BackgroundMapCustomColorOptions;

  return {
    backgroundColor: customColorOptions.custom_background_color ?? backgroundMapCustomStyleDefaults.backgroundColor,
    waterColor: customColorOptions.custom_water_color ?? backgroundMapCustomStyleDefaults.waterColor,
    borderColor: customColorOptions.custom_border_color ?? backgroundMapCustomStyleDefaults.borderColor,
  };
}

export function withCustomBackgroundMapColorDefaults(
  styleId: string,
  customOptions: BackgroundMapCustomOptions | null | undefined,
) {
  const baseCustomOptions = (customOptions ?? {}) as BackgroundMapCustomOptions & BackgroundMapCustomColorOptions;
  if (!isCustomBackgroundMapStyle(styleId)) {
    return baseCustomOptions;
  }

  const colors = resolveCustomBackgroundMapColors(baseCustomOptions);
  return {
    ...baseCustomOptions,
    custom_background_color: colors.backgroundColor,
    custom_water_color: colors.waterColor,
    custom_border_color: colors.borderColor,
  };
}
